import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import TrainingLogHeader from './components/training-log-header/training-log-header.component';
import { TrainingLogProvider } from './training-log.context';
import { getActiveTrainingLogTab } from './training-log.constants';
import DashboardPage from './pages/dashboard/dashboard.page';
import DataInfoPage from './pages/data-info/data-info.page';
import LogPage from './pages/log/log.page';
import RawDataPage from './pages/raw-data/raw-data.page';
import './training-log.page.css';

export interface TrainingLogPageProps {
  tab?: string;
}

const TrainingLogPage: FC<TrainingLogPageProps> = (props) => {
  const location = useLocation();
  const activeTab = props.tab ?? getActiveTrainingLogTab(location.pathname);

  const displaySubpage = () => {
    switch (activeTab) {
      case 'training-log':
        return <LogPage />;
      case 'raw-data':
        return <RawDataPage />;
      case 'data-info':
        return <DataInfoPage />;
      case 'dashboard':
      default:
        return <DashboardPage />;
    }
  };

  return (
    <TrainingLogProvider>
      <div className={window.localStorage.getItem('sidedrawer') ? 'page-full' : 'page'} id="page">
        <div className={`training-log-page${activeTab === 'raw-data' ? ' training-log-page--raw-data' : ''}`}>
          <TrainingLogHeader />
          <div className="training-log-content">{displaySubpage()}</div>
        </div>
      </div>
    </TrainingLogProvider>
  );
};

export default TrainingLogPage;
